import { generateQuotationPdf, quotationPdfAssets } from './adminQuotationPdf';
let ready;
const prepare = () => ready ||= Promise.all(quotationPdfAssets.map(src => new Promise((resolve, reject) => {
  const image = new Image(); image.onload = resolve; image.onerror = () => { ready = null; reject(new Error('Impossible de charger un visuel du devis.')); }; image.src = src;
})));
export const generatePDF = async (quotation, viewOnly = false, setIsLoadingQuotation = null, outputMode = 'open') => {
  try {
    await prepare();
    if (!quotation.products?.length) throw new Error('Ajoutez une prestation au devis.');
    const agency = quotation.agency || {};
    return generateQuotationPdf({
      ...quotation,
      client: { companyName: '', siret: '', TVA: '', facturation: '', ...quotation.client },
      agency: { name: '', address: '', postCode: '', town: '', siret: '', tva: agency.TVA || '', email: '', phone: '', ...agency },
    }, { asUrl: outputMode === 'url', download: !viewOnly && outputMode !== 'url' });
  } finally { setIsLoadingQuotation?.(false); }
};
